import React from 'react'
import Item from './list-item'
import createReactClass from 'create-react-class'
import { getMyStatements } from '../actions'

const searchDiv = {
  'margin': 'auto',
  'width': '100%',
  'padding': '10px'
}
const header = {
  'paddingLeft': '10px',
  'float' : 'left'
}
const input = {
  'borderRadius': '5px',
  'height' : '30px'
}

export default createReactClass({
  displayName: 'Statements',

  getInitialState () {
    return {
      selectedDealer: null,
      dealerSearchTerm: '',
      showDealerDropdown: false
    }
  },

  handleSearch (e) {
    e.preventDefault()
    // Get statements with potential dealer impersonation
    getMyStatements({
      dealerId: this.state.selectedDealer
    })
    this.forceUpdate()
  },

  handleDealerChange (e) {
    this.setState({ selectedDealer: e.target.value })
  },

  handleDealerSearchChange (e) {
    const value = e.target.value
    this.setState({ 
      dealerSearchTerm: value,
      selectedDealer: value, // Update selectedDealer with typed value
      showDealerDropdown: true 
    })
  },

  handleDealerSelect (accountNumber) {
    this.setState({ 
      selectedDealer: accountNumber,
      dealerSearchTerm: accountNumber,
      showDealerDropdown: false 
    })
  },

  handleDealerInputFocus () {
    this.setState({ showDealerDropdown: true })
  },

  handleDealerInputBlur () {
    // Delay hiding to allow clicks on dropdown items
    setTimeout(() => this.setState({ showDealerDropdown: false }), 200)
  },

  getDates () {
    let returnVals = []
    returnVals[0] = ""
    for (var i = 1; i <= 12; i++) {
      returnVals[i] = ((new Date().getMonth()-i+2 > 0) ? new Date().getMonth() - i + 2: new Date().getMonth() - i + 14) + "/" + ((new Date().getMonth()-i+1 >= 0) ? new Date().getFullYear() : new Date().getFullYear() - 1)
    }
    return returnVals
  },

  filter (searchAcct, search, acct, date) {
    date = new Date(date)
    if (!searchAcct && !search) return true
    if (search.length > 0 && search !== ((+date.getMonth()+1) + "/" + date.getUTCFullYear())) return false
    if (! (acct.indexOf(searchAcct)> -1)) return false
    return true
  },

  render () {
    const monthNames = new Array(12)
    monthNames[0] = "January"
    monthNames[1] = "February"
    monthNames[2] = "March"
    monthNames[3] = "April"
    monthNames[4] = "May"
    monthNames[5] = "June"
    monthNames[6] = "July"
    monthNames[7] = "August"
    monthNames[8] = "September"
    monthNames[9] = "October"
    monthNames[10] = "November"
    monthNames[11] = "December"

    const session = this.props.session
    const user = this.props.session.user
    const dealers = this.props.dealers
    const hasPrivilegedRole =
      user.roles &&
      user.roles.some(role => {
        return ['DataProvider', 'Administrator', 'Sales'].includes(role)
      })

    // Filter dealers based on search term
    const filteredDealers = dealers && dealers.data ? 
      dealers.data.filter(dealer => 
        dealer.attributes.accountNumber && 
        dealer.attributes.accountNumber.toString().toLowerCase().includes(this.state.dealerSearchTerm.toLowerCase())
      ) : []
    const Statements = this.props.statements.data
      .sort((a,b) => a.attributes.metadata.date < b.attributes.metadata.date)
      .filter(statement => {
        if (this.filter(
          (this.refs.searchAcct?this.refs.searchAcct.value:""),
          (this.refs.search?this.refs.search.value:""),
          statement.attributes.metadata.acctNo,
          statement.attributes.metadata.date)
        ) {
          return true
        }
        else return false
      })
      .map(statement => {
      return (
        <Item
          key={statement.id}
          {...statement.attributes}
          hasPrivilegedRole={hasPrivilegedRole}
          session={session}
          search={(this.refs.search?this.refs.search.value:null)}
        />
      )
    })
    const Dates = this.getDates().map(months => {
      return (
        <option key={months} value={months}>{months === ""? "Date" : monthNames[months.split('/')[0]-1] + " " + months.split('/')[1]}</option>
      )
    })
    return (
      <div className="statements">
        <br/>
        <h1 style={header}>Statements</h1>
        <br/>

        <div className="row form-group" style={searchDiv}>
              <div className="col-lg-2 col-xs-12">Statement Date: <select className="atlas-select form-control" onChange={this.handleSearch} ref="search">
                  {Dates}
                </select></div> 
                {user.managesMultipleLocales ? <div className="col-lg-2 col-xs-12">Account #: <input className="form-control" style={input} onChange={this.handleSearch} ref="searchAcct"/></div> : null}
        </div>

        {hasPrivilegedRole && (
          <div className="row form-group" style={searchDiv}>
            <div className="col-lg-4 col-xs-12" style={{ position: 'relative' }}>
              <label>View as Dealer (Admin Only):</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter dealer account number..."
                value={this.state.dealerSearchTerm}
                onChange={this.handleDealerSearchChange}
                onFocus={this.handleDealerInputFocus}
                onBlur={this.handleDealerInputBlur}
              />
              {this.state.showDealerDropdown && (filteredDealers.length > 0 || this.state.dealerSearchTerm) && (
                <div style={{
                  position: 'absolute',
                  top: '100%',
                  left: '0',
                  right: '0',
                  backgroundColor: 'white',
                  border: '1px solid #ccc',
                  borderTop: 'none',
                  maxHeight: '200px',
                  overflowY: 'auto',
                  zIndex: 1000
                }}>
                  {filteredDealers.slice(0, 10).map(dealer => (
                    <div
                      key={dealer.id}
                      style={{
                        padding: '8px 12px',
                        cursor: 'pointer',
                        borderBottom: '1px solid #eee'
                      }}
                      onMouseDown={(e) => {
                        e.preventDefault()
                        this.handleDealerSelect(dealer.attributes.accountNumber)
                      }}
                      onMouseOver={(e) => {
                        e.target.style.backgroundColor = '#f5f5f5'
                      }}
                      onMouseOut={(e) => {
                        e.target.style.backgroundColor = 'white'
                      }}
                    >
                      {dealer.attributes.accountNumber}
                    </div>
                  ))}
                  {this.state.dealerSearchTerm && !filteredDealers.some(d => d.attributes.accountNumber === this.state.dealerSearchTerm) && (
                    <div
                      style={{
                        padding: '8px 12px',
                        cursor: 'pointer',
                        borderBottom: '1px solid #eee',
                        fontStyle: 'italic',
                        backgroundColor: '#f8f9fa'
                      }}
                      onMouseDown={(e) => {
                        e.preventDefault()
                        this.handleDealerSelect(this.state.dealerSearchTerm)
                      }}
                      onMouseOver={(e) => {
                        e.target.style.backgroundColor = '#e9ecef'
                      }}
                      onMouseOut={(e) => {
                        e.target.style.backgroundColor = '#f8f9fa'
                      }}
                    >
                      Use "{this.state.dealerSearchTerm}" (not in dealer list)
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        )}

        <table className="table table-striped table-sm table-bordered atlas-detailed-result-table">
          <thead className="statementsItem">
            <tr>
              <th className="statementsItem-cell">
                Statement Name
              </th>
              {user.managesMultipleLocales ? 
              (<th className="statementsItem-cell">
                Account #
              </th>)
              :
              null
              }
            </tr>
          </thead>
          <tbody>
            {Statements}
          </tbody>
        </table>
      </div>
    )
  }
})

// import React from 'react'

// export default function Statements () {
//   return (
//     <div>
//       <p>
//         Statements are currently not available. If you require any copies, please contact your local branch.
//       </p>
    
//     </div>
//   )
// }

